import { APIResponse } from '@cbgms/api'
import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'

import { MediaCategory } from './media-category'

export type UploadImageResponse = APIResponse<{
  URL: string
  Success: boolean
  SizeInBytes: number
}>

export const uploadImage = (category: MediaCategory, file: File) =>
  createAsyncApiAction<UploadImageResponse>('support', {
    method: 'POST',
    url: `/modules/media/images/${category}/${file.name}`,
    data: file
  })
